import { CardSkeleton, ProfileSkeleton } from "@/components/Skeleton";

export default function JobDetailsSkeleton() {
  return (
    <div className="flex flex-col" data-testid="job-details-skeleton">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="col-span-1 md:col-span-4 mt-12" data-testid="job-details-skeleton-sidebar">
          {[1, 2, 3, 4].map((i) => (
            <CardSkeleton key={i} width={100} className="mb-6" rows={4} />
          ))}
        </div>
        <div className="col-span-1 md:col-span-8 mt-12" data-testid="job-details-skeleton-main">
          {[1, 2, 3, 4].map((i) => (
            <CardSkeleton key={i} width={100} className="mb-6" rows={8} />
          ))}
          <ProfileSkeleton />
        </div>
      </div>
    </div>
  );
}
